module.exports = __webpack_public_path__ + "CreativeDirection23.jpg?2b8bf4836cbec660a614bad0c65d010c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection23.jpg
// module id = 35
// module chunks = 0